import { render } from "./CreateNewAssements.vue?vue&type=template&id=440d6c02"
import script from "./CreateNewAssements.vue?vue&type=script&lang=js"
export * from "./CreateNewAssements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__